export default __webpack_public_path__ + "static/media/Head_6_Ear_3_C5.d362e890.svg";